import { render, staticRenderFns } from "./title.vue?vue&type=template&id=5b757a9f&scoped=true&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"
import style0 from "./title.vue?vue&type=style&index=0&id=5b757a9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b757a9f",
  null
  
)

export default component.exports